import { render, staticRenderFns } from "./MergeOrderEdit.vue?vue&type=template&id=31ba1ac8&scoped=true&"
import script from "./MergeOrderEdit.vue?vue&type=script&lang=js&"
export * from "./MergeOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./MergeOrderEdit.vue?vue&type=style&index=0&id=31ba1ac8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ba1ac8",
  null
  
)

export default component.exports